import { Editor } from '@tiptap/vue-2'
import { createMarkdownEditor } from "../MarkdownEditor";
import StarterKit from '@tiptap/starter-kit'
import Blockquote from "@tiptap/extension-blockquote"
import Table from '@tiptap/extension-table'
import TableCell from '@tiptap/extension-table-cell'
import TableHeader from '@tiptap/extension-table-header'
import TableRow from '@tiptap/extension-table-row'
import TaskItem from '@tiptap/extension-task-item'
import TaskList from '@tiptap/extension-task-list'
import Reference from "../extensions/reference";
import {Image} from "@tiptap/extension-image";
import TecnaSuggestions from '../extensions/suggestions'
import {CharacterCount} from "@tiptap/extension-character-count";

function tiptapConfiguration(configuration) {
  return [
    StarterKit.configure({
      codeBlock: false,
    }),
    CharacterCount.configure({
      limit: configuration.maxCharacterCount,
    }),
    Blockquote,
    TableRow,
    TableHeader,
    TableCell,
    Table.configure({
      resizable: true,
      HTMLAttributes: {
        class: 'markdown-table',
      },
    }),
    TaskList,
    TaskItem,
    Image.configure({
      allowBase64: true,
      HTMLAttributes: {
        class: 'insert-img',
      },
    }),
    configuration.usersSuggestion != null ? TecnaSuggestions.configure({
      usersSuggestion: configuration.usersSuggestion,
      filesSuggestion: configuration.filesSuggestion,

    }) : null,
    Reference,
  ]
}

export function createEditor(content, configuration) {
  const MarkdownEditor = createMarkdownEditor(Editor);
  return new MarkdownEditor({
    editorProps: {
      attributes: {
        class: 'tcn-editor',
      },
    },
    content: content,
    extensions: tiptapConfiguration(configuration),
  })
}
